import {
  forEach,
} from 'lodash';
import { v4 as s4 } from 'uuid';

/**
 Prepare bets for ticket
 */
const prepareBets = (betsData, ticketType) => {
  const bets = [];
  forEach(betsData, (bet) => {
    bets.push({
      eventId: bet.roundNumber,
      marketId: bet.marketId,
      outcomeType: bet.outcomeType,
      outcomeOdd: +bet.odds,
      outcomeCode: bet.outcomeCode,
      stake: ticketType === 'single' ? bet.stake : 0,
    });
  });
  return bets;
};

/**
 * Here we will prepare ticket for platform
 *
 * @param data {object}
 * @param cpvUuid {string}
 * @param reqUuid {string}
 * @returns {{metadata: {product, sources: [{firstName: string|*, lastName: string|*,
 * type: string, uuid: *, username: *}], requestUuid, paymentMethod: string, cpvUuid,
 * deliveryPlatform: string}, ticket: {ticketOddsOptions: number, payin: (null|boolean|string|*),
 * ticketCombinationGroups: [], ticketType: (number|*), bets: []}}}
 */
const makeTicketData = (data, cpvUuid, reqUuid) => {
  const bets = prepareBets(data.bets, data.ticketType);
  const uuid = data.user.user.profile.id;
  return {
    metadata: {
      product: data.product,
      deliveryPlatform: data.deliveryPlatform,
      cpvUuid,
      paymentMethod: 'VirtualMoney',
      requestUuid: reqUuid,
      sources: [
        {
          type: 'player',
          uuid,
          username: data.user.user.profile.email,
          firstName: data.user.user.profile.firstName,
          lastName: data.user.user.profile.lastName,
        },
      ],
      currency: data.currency,
    },
    ticket: {
      bets,
      payin: data.payin,
      ticketCombinationGroups: [],
      ticketType: data.ticketType,
      ticketOddsOptions: 2,
    },
  };
};

/**
 * Create request uuid of 36 characters
 * @returns {string}
 */
const makeRequestUuid = () => {
  return s4();
};

const prepareTicketRequest = (data) => {
  const gameUuid = data.config.productId;
  const reqUuid = makeRequestUuid();
  return makeTicketData(data, gameUuid, reqUuid);
};

const ignitePrepareBetslipBetsRequest = (data) => {
  const bets = [];
  if (data.ticketType.value === 'single') {
    forEach(data.bets, (bet) => {
      bets.push({
        stake: bet.stake,
      });
    });
  } else {
    bets.push({
      stake: data.payin,
    });
  }
  return bets;
};

export { prepareTicketRequest, prepareBets, ignitePrepareBetslipBetsRequest };
